import React from 'react';
import FeatureFlagGate from '../../containers/FeatureFlagGate';
import { Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import hipagesLogo from './upload/assets/hipages.jpg';
import governmentLogo from './upload/assets/gov.jpg';
import { Frame, colors } from 'hui';
import { HipagesLogo, LogoZone, NSWGovernmentLogoImg } from './style';
import styled from 'styled-components';

const RedirectToHomePage = <Redirect to="/" />;

const Header = () => (
  <Helmet>
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/antd/3.25.3/antd.min.css" />
  </Helmet>
);

const Wrap = styled.div`
  background: ${colors.tint4};
  @media (min-width: 1025px) {
    padding: 0 22rem 6rem;
  }
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  background: ${colors.tint6};
  padding: 2rem;
  border-radius: 0.5rem;
`;

const Doe: React.FC = ({ children }) => {
  return (
    <FeatureFlagGate featureName="doe-upload-page" fallback={RedirectToHomePage}>
      <Header />
      <Frame size={0}>
        <Wrap>
          <LogoZone>
            <HipagesLogo alt="Hipages Logo" src={hipagesLogo} />
            <NSWGovernmentLogoImg alt="NSW Government Logo" src={governmentLogo} />
          </LogoZone>
          <Content>{children}</Content>
        </Wrap>
      </Frame>
    </FeatureFlagGate>
  );
};

export default Doe;
